/* global femcare */

femcare.video.platformVideo.init = function () {

    this.$inlineVideos = $('.video-inline');
    this.$modalPlayTriggers = $('.js-play-video-modal');
    this.$allVideoTriggers = this.$inlineVideos.add(this.$modalPlayTriggers);

    var platformVideosExist = this.$allVideoTriggers.length > 0;
    if (platformVideosExist) {

        this.$allVideoTriggers.on('click', $.proxy(function (e) {

            this.$allVideoTriggers.off('click');

            var $clickedElement = $(e.target);

            this.assetsPath = femcare.shared.util.getAssetsPath();
            var jwplayerPath = this.assetsPath + '/js/vendor/jwplayer/jwplayer.js';

            $.getScript(jwplayerPath, $.proxy(function () {

                this.activePlayer = null;
                this.videoOptions = { skin: 'femcare' };

                if (this.$inlineVideos.length) {
                    this.initInlineVideoPlayers();
                }
                if (this.$modalPlayTriggers.length) {
                    this.initModalVideoPlayer();
                }

                // Hotfix: wait until platform video is ready
                setTimeout(function () {
                    $clickedElement.click();
                }, 600);

            }, this));

        }, this));
    }
};